import React from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";

const macroWidth = 100;
const menuColWidth = 40;

export default React.memo(() => {
  return (
    <Box>
      <Box style={{ paddingTop: 8, paddingLeft: 8 }}>
        <Grid
          container
          wrap="nowrap"
          alignItems="center"
          columnSpacing={1}
          sx={{ flexWrap: "nowrap", overflowX: "auto" }}
        >
          <Grid
            item
            sx={{
              flex: "1 1 auto",
              minWidth: 200,
            }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Name
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Protein
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Carbs
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Fats
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              kCals
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Water
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 18, fontWeight: "normal", marginTop: 0 }}
            >
              Fiber
            </Typography>
          </Grid>

          <Grid
            item
            sx={{
              width: menuColWidth,
              minWidth: menuColWidth,
              flexShrink: 0,
            }}
            aria-hidden
          />
        </Grid>
      </Box>
      <Divider
        style={{
          marginBottom: 8,
          borderRadius: 1,
          color: "black",
        }}
      />
    </Box>
  );
});
